import React, { useRef, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const SearchInput = React.memo(({ value, onChange, placeholder = "Search members..." }: SearchInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  // Maintain focus when the component re-renders
  useEffect(() => {
    if (document.activeElement === inputRef.current) {
      inputRef.current?.focus();
    }
  });

  return (
    <div className="relative max-w-sm">
      <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
      <Input
        ref={inputRef}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-10"
      />
    </div>
  );
});

SearchInput.displayName = 'SearchInput';